import { NextSeo } from 'next-seo'
import styled from 'styled-components'
import DefaultPageLayout from '~/components/templates/DefaultPageLayout'

export default function HelpPage() {
  return (
    <DefaultPageLayout>
      <NextSeo
        title='プライバシーポリシー'
        openGraph={{
          url: `${process.env.origin}/policy`,
          title: 'プライバシーポリシー - Ambass'
        }}
      />
      <Title>プライバシーポリシー</Title>
      <Container>
        <Row>
          <Description>
            September6合同会社（以下「当社」といいます。）は、お客様の個人情報保護の重要性について認識し、個人情報の保護に関する法律（以下「個人情報保護法」といいます。）を遵守すると共に、以下のプライバシーポリシー（以下「本プライバシーポリシー」といいます。）に従い、適切な取扱い及び保護に努めます。
          </Description>
        </Row>
        <Row>
          <Header>1.個人情報の定義</Header>
          <Description>
            本プライバシーポリシーにおいて、個人情報とは、個人情報保護法第2条第1項により定義された個人情報、すなわち、生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日その他の記述等により特定の個人を識別することができるもの（他の情報と容易に照合することができ、それにより特定の個人を識別することができることとなるものを含みます。）を意味するものとします。
          </Description>
        </Row>
        <Row>
          <Header>2.個人情報の利用目的</Header>
          <Description>当社は、お客様の個人情報を、以下の目的で利用致します。</Description>
          <List>
            <ListContainer>
              当社サービス（以下総称して「当社サービス」といいます。）の提供のため
            </ListContainer>
            <ListContainer>当社サービスに関するご案内、お問い合わせ等への対応のため</ListContainer>
            <ListContainer>
              当社サービスに関する当社の規約、ポリシー等（以下「規約等」といいます。）に違反する行為に対する対応のため
            </ListContainer>
            <ListContainer>当社サービスに関する規約等の変更などを通知するため</ListContainer>
            <ListContainer>
              当社サービスの改善、当社及び当社の関連会社の新サービスの開発等に役立てるため
            </ListContainer>
            <ListContainer>
              当社サービスに関連して、個別を識別できない形式に加工した統計データを作成するため
            </ListContainer>
            <ListContainer>その他、上記利用目的に付随する目的のため</ListContainer>
          </List>
        </Row>
        <Row>
          <Header>3.個人情報利用目的の変更</Header>
          <Description>
            当社は、個人情報の利用目的を相当の関連性を有すると合理的に認められる範囲内において変更することがあり、変更した場合にはお客様に通知又は公表します。
          </Description>
        </Row>
        <Row>
          <Header>4.個人情報利用の制限</Header>
          <Description>
            当社は、個人情報保護法その他の法令により許容される場合を除き、お客様の同意を得ず、利用目的の達成に必要な範囲を超えて個人情報を取り扱いません。但し、次の場合はこの限りではありません。
            <List>
              <ListContainer>法令に基づく場合</ListContainer>
              <ListContainer>
                人の生命、身体又は財産の保護のために必要がある場合であって、お客様の同意を得ることが困難であるとき
              </ListContainer>
              <ListContainer>
                公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、お客様の同意を得ることが困難であるとき
              </ListContainer>
              <ListContainer>
                国の機関もしくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、お客様の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき
              </ListContainer>
            </List>
          </Description>
        </Row>
        <Row>
          <Header>5.個人情報の適正な取得</Header>
          <Description>
            当社は、適正に個人情報を取得し、偽りその他不正の手段により取得しません。
          </Description>
        </Row>
        <Row>
          <Header>6.個人情報の安全管理</Header>
          <Description>
            当社は、個人情報の紛失、破壊、改ざん及び漏洩などのリスクに対して、個人情報の安全管理が図られるよう、当社の従業員に対し、必要かつ適切な監督を行います。また、当社は、個人情報の取扱いの全部又は一部を委託する場合は、委託先において個人情報の安全管理が図られるよう、必要かつ適切な監督を行います。
          </Description>
        </Row>
        <Row>
          <Header>7.第三者提供</Header>
          <Description>
            当社は、個人情報保護法その他の法令に基づき開示が認められる場合を除くほか、あらかじめお客様の同意を得ないで、個人情報を第三者に提供しません。但し、次に掲げる場合は上記に定める第三者への提供には該当しません。
            <List>
              <ListContainer>法令に基づく場合</ListContainer>
              <ListContainer>
                当社が利用目的の達成に必要な範囲内において個人情報の取扱いの全部又は一部を委託する場合
              </ListContainer>
              <ListContainer>
                合併その他の事由による事業の承継に伴って個人情報が提供される場合
              </ListContainer>
              <ListContainer>個人情報保護法の定めに基づき共同利用する場合</ListContainer>
            </List>
          </Description>
        </Row>
        <Row>
          <Header>8.個人情報の開示</Header>
          <Description>
            当社は、お客様から、個人情報保護法の定めに基づき個人情報の開示を求められたときは、お客様ご本人からのご請求であることを確認の上で、お客様に対し、遅滞なく開示を行います（当該個人情報が存在しないときにはその旨を通知いたします。）。但し、個人情報保護法その他の法令により、当社が開示の義務を負わない場合は、この限りではありません。
          </Description>
        </Row>
        <Row>
          <Header>9.個人情報の訂正等</Header>
          <Description>
            当社は、お客様から、個人情報が真実でないという理由によって、個人情報保護法の定めに基づきその内容の訂正、追加又は削除（以下「訂正等」といいます。）を求められた場合には、お客様ご本人からのご請求であることを確認の上で、利用目的の達成に必要な範囲内において、遅滞なく必要な調査を行い、その結果に基づき、個人情報の内容の訂正等を行い、その旨をお客様に通知します（訂正等を行わない旨の決定をしたときは、お客様に対しその旨を通知いたします。）。但し、個人情報保護法その他の法令により、当社が訂正等の義務を負わない場合は、この限りではありません。
          </Description>
        </Row>
        <Row>
          <Header>10.個人情報の利用停止等</Header>
          <Description>
            当社は、お客様から、お客様の個人情報が、あらかじめ公表された利用目的の範囲を超えて取り扱われているという理由又は偽りその他不正の手段により取得されたものであるという理由により、個人情報保護法の定めに基づきその利用の停止又は消去（以下「利用停止等」といいます。）を求められた場合において、そのご請求に理由があることが判明した場合には、お客様ご本人からのご請求であることを確認の上で、遅滞なく個人情報の利用停止等を行い、その旨をお客様に通知します。但し、個人情報保護法その他の法令により、当社が利用停止等の義務を負わない場合は、この限りではありません。
          </Description>
        </Row>
        <Row>
          <Header>11.Cookie（クッキー）その他の技術の利用</Header>
          <Description>
            当社のサービスは、ユーザーにより快適なサービス環境を提供するため、当社サービスではユーザーがカスタマイズした表示などの設定の保存にCookie及びこれに類する技術を利用することがあります。
          </Description>
          <Description>
            これらの技術は、当社による当社のサービスの利用状況等の把握に役立ち、サービス向上に資するものです。Cookieを無効化されたいユーザーは、ウェブブラウザの設定を変更することによりCookieを無効化することができます。但し、Cookieを無効化すると、アカウント認証ができなくなるなど、当社のサービスの一部の機能をご利用いただけなくなる場合があります。
          </Description>
          <Description>
            また、当社は本サービスの利用状況等を調査・分析するため、本サービス上にGoogle社が提供するGoogleAnalyticsを利用しています。GoogleAnalyticsでデータが収集、処理される仕組みその他GoogleAnalyticsの詳しい情報につきましては、同社のサイトをご覧ください。
          </Description>
          <Description>
            GoogleAnalytics利用規約
            <br />
            <StyledAnchor
              href='https://www.google.com/analytics/terms/jp.html'
              target='_blank'
              rel='noopener noreferrer'
            >
              https://www.google.com/analytics/terms/jp.html
            </StyledAnchor>
          </Description>
          <Description>
            お客様がGoogleパートナーのサイトやアプリを使用する際のGoogleによるデータ使用
            <br />
            <StyledAnchor
              href='https://www.google.com/intl/ja/policies/privacy/partners/'
              target='_blank'
              rel='noopener noreferrer'
            >
              https://www.google.com/intl/ja/policies/privacy/partners/
            </StyledAnchor>
          </Description>
          <Description>
            Google プライバシーポリシー
            <br />
            <StyledAnchor
              href='http://www.google.com/intl/ja/policies/privacy/'
              target='_blank'
              rel='noopener noreferrer'
            >
              http://www.google.com/intl/ja/policies/privacy/
            </StyledAnchor>
          </Description>
          <Description>
            なお、お客様はご自身のデータがGoogleAnalyticsで使用されることを望まない場合は、Google社の提供する
            GoogleAnalyticsオプトアウトアドオンをご利用ください。
          </Description>
        </Row>
        <Row>
          <Header>12.クレジットカード決済利用に際して入力いただく情報について</Header>
          <Description>
            ユーザーがクレジットカード決済を利用する際に入力いただくクレジットカード番号全桁を含むクレジットカード情報は、当社では取得せず、決済代行事業者が直接ユーザーから取得し、決済代行事業者に登録されます。
          </Description>
          <Description>
            当社は、本サービスに関してクレジットカードによる不正決済が発生した場合等、ユーザーの安全なクレジットカード決済環境を確保するため、利用する決済代行事業者を切り替えることがあります。この場合、ユーザーがクレジットカード決済を継続してご利用いただく環境の確保を目的として、前項に定める決済代行事業者がユーザーから取得したクレジットカード情報を、当該決済代行事業者が切り替え先の決済代行事業者に対して提供することがあります。
          </Description>
        </Row>
        <Row>
          <Header>13.アカウント維持等に必要な個人情報について</Header>
          <Description>
            メールアドレス等の本サービスにおけるユーザーアカウントの維持、本サービス利用に必須の個人情報について、ユーザーがその提供に同意しない場合は、本サービスを利用することはできません。
          </Description>
        </Row>
        <Row>
          <Header>14.免責</Header>
          <Description>
            次に掲げる場合を含む第三者による個人情報の取得に関し、当社は一切の責任を負いません。
            <List>
              <ListContainer>法令に基づく場合</ListContainer>
              <ListContainer>
                ユーザーご本人が当社サービスの機能または別の手段を用いて第三者に個人情報を明らかにした場合
              </ListContainer>
              <ListContainer>
                TLS非対応ブラウザによる本サービスでのアカウント作成、申込もしくは注文、または電子メールもしくは郵便によりユーザー情報をご提供いただき、当社への情報到達過程にて、当社の管理外の第三者に閲覧、窃取された場合
              </ListContainer>
              <ListContainer>
                当社によるセキュリティ施策にもかかわらず、不正アクセスにより、ユーザーおよび第三者に損害が生じた場合
              </ListContainer>
              <ListContainer>
                当社が推奨していないサードパーティアプリを使って本サービスを利用した場合
              </ListContainer>
            </List>
          </Description>
        </Row>
        <Row>
          <Header>15.お問い合わせ</Header>
          <Description>
            〒169-0072
            <br />
            東京都新宿区大久保2-7-1
            <br />
            大久保フジビル
            <br />
            September6合同会社
          </Description>
          <Description>
            連絡先: support@ambass.me
            <br />
            （なお、受付時間は、平日10時から18時までとさせてただきます。）
          </Description>
        </Row>
        <Row>
          <Header>16.継続的改善</Header>
          <Description>
            当社は、個人情報の取扱いに関する運用状況を適宜見直し、継続的な改善に努めるものとし、必要に応じて、本プライバシーポリシーを変更することがあります。
          </Description>
        </Row>
        <Row>
          <Description>2021年07月24日制定</Description>
        </Row>
      </Container>
    </DefaultPageLayout>
  )
}

const Title = styled.div`
  text-align: center;
  margin: 40px 24px;
  ${({ theme }) => theme.fonts.Bold20};
  color: ${({ theme }) => theme.colors.OnSurface2};
`
const Container = styled.div`
  display: grid;
  grid-gap: 24px;
`
const Row = styled.div``
const Header = styled.div`
  margin-bottom: 8px;
  ${({ theme }) => theme.fonts.Bold20};
  color: ${({ theme }) => theme.colors.OnSurface5};
`
const Description = styled.div`
  ${({ theme }) => theme.fonts.Bold16};
  color: ${({ theme }) => theme.colors.OnSurface2};
  margin-bottom: 8px;
`
const List = styled.ul`
  ${({ theme }) => theme.fonts.Bold16};
  color: ${({ theme }) => theme.colors.OnSurface2};
`
const ListContainer = styled.li`
  list-style-type: lower-roman;
`
const StyledAnchor = styled.a`
  word-break: break-all;
  text-decoration: none;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.Primary};
`
